module.exports = __webpack_public_path__ + "static/media/departure-icon.cd81beb4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bus-eireann/departure-icon.svg
// module id = 637
// module chunks = 0